// import React, { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import PartnerApi from "../../../helpers/PartnerApi";
// import LicenseHistoryModal from "../../../admin/licence/LicenseHistoryModal";
// import { formatDateByLang } from "../../function/formatDate";
// import { formatDateTimeByLang } from "../../function/formatDateTimeByLang";

// // ✅ kendi dosya yoluna göre düzelt
// import LicenseHolderInfo from "./LicenseHolderInfo";

// const LicenceList = ({ data }) => {
//   const { i18n, t } = useTranslation();

//   const languageOptions = [
//     { label: "TURKISH", value: "40" },
//     { label: "GERMAN", value: "1" },
//     { label: "ENGLISH", value: "3" },
//     { label: "FRENCH", value: "5" },
//     { label: "ARABIC", value: "19" },
//   ];

//   const [countryOptions, setCountryOptions] = useState([]);
//   const [moduleOptions, setModuleOptions] = useState([]);

//   const [myFilter, setMyFilter] = useState({
//     status: 1,
//     language: "40",
//     country: "",
//     moduleCode: "",
//   });

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedLicense, setSelectedLicense] = useState(null);

//   // ✅ Responsive + value ekrana sığsın + JSX value bozulmasın
//   const InfoRow = ({ label, value }) => {
//     const isReactNode = React.isValidElement(value);

//     const showValue =
//       value === null || value === undefined || value === "" ? "" : String(value);

//     return (
//       <div
//         className="
//           grid
//           grid-cols-[minmax(110px,150px)_1fr]
//           sm:grid-cols-[minmax(160px,220px)_1fr]
//           lg:grid-cols-[minmax(220px,320px)_1fr]
//           gap-x-3 gap-y-1
//           items-start
//           min-w-0
//           transition-colors duration-300
//         "
//       >
//         {/* Label: küçük ekranda daralır, tek satır + ... */}
//         <span
//           className="
//             font-medium
//             text-gray-800 dark:!text-white
//             whitespace-nowrap truncate
//             min-w-0
//           "
//           title={label}
//         >
//           {label}:
//         </span>

//         {/* Value: taşarsa satır kır, container dışına çıkma */}
//         <span
//           className="
//             min-w-0
//             text-gray-700 dark:!text-white
//             break-words whitespace-normal
//             text-left
//             font-bold
//           "
//         >
//           {isReactNode ? value : showValue}
//         </span>
//       </div>
//     );
//   };

//   const getLabelByValue = (options, value) => {
//     const v = value ?? "";
//     const found = (options || []).find((o) => String(o.value) === String(v));
//     return found?.label || "";
//   };

//   const stripSeconds = (s = "") =>
//     String(s).replace(/(\d{1,2}:\d{2})(?::\d{2})/, "$1");

//   const supportValidationLabelMap = {
//     S2: "+2 months of support (max 10 calls)",
//     SI: "The invoice may not have arrived!",
//     SA: "Support will be provided in all cases",
//     XX: "No support",
//   };

//   const supportValidationCode = String(data?.supportValidation ?? "")
//     .trim()
//     .toUpperCase();

//   const supportValidationLabel =
//     supportValidationLabelMap[supportValidationCode] ||
//     supportValidationCode ||
//     "";

//   const supportTypeLabelMap = {
//     "": "A vérifier",
//     A0: "Update",
//     A1: "Telephonic",
//     A2: "Remote",
//     A3: "On site",
//     N1: "Unwanted",
//     N2: "No proposed",
//     N3: "Letter send",
//   };

//   const supportTypeCode = String(data?.supportType ?? "").trim();
//   const supportTypeLabel =
//     data?.supportTypeName ||
//     supportTypeLabelMap[supportTypeCode] ||
//     supportTypeCode ||
//     "";

//   const toDateOnly = (d) => {
//     if (!d) return null;
//     const dt = new Date(d);
//     if (Number.isNaN(dt.getTime())) return null;
//     return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
//   };

//   const isTodayInRange = (start, end) => {
//     const s = toDateOnly(start);
//     const e = toDateOnly(end);
//     if (!s || !e) return true;
//     const today = toDateOnly(new Date());
//     return today >= s && today <= e;
//   };

//   const supportStart = data?.supportStartDate;
//   const supportFinish = data?.supportFinishDate;
//   const inSupportPeriod = isTodayInRange(supportStart, supportFinish);

//   const supportPeriodText = `${formatDateByLang(supportStart, i18n.language) || ""} - ${
//     formatDateByLang(supportFinish, i18n.language) || ""
//   }`;

//   // ✅ Countries
//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const res = await PartnerApi.getCountryList({
//           language: myFilter.language || "40",
//           status: myFilter.status ?? 1,
//           limit: 500,
//           offset: 0,
//         });

//         const list = Array.isArray(res?.countryList) ? res.countryList : [];
//         const options = list
//           .filter((c) => String(c?.name || "").trim())
//           .sort((a, b) => String(a.name).localeCompare(String(b.name)))
//           .map((c) => ({
//             label: String(c.name).trim(),
//             value: String(c.code ?? c.countryCode ?? c.id ?? "").trim(),
//           }))
//           .filter((x) => x.value);

//         setCountryOptions(options);

//         setMyFilter((prev) => ({
//           ...prev,
//           country: prev.country || options?.[0]?.value || "",
//         }));
//       } catch (error) {
//         console.error("Ülke listesi alınamadı:", error);
//       }
//     };

//     fetchCountries();
//   }, [myFilter.language, myFilter.status]);

//   // ✅ Modules
//   useEffect(() => {
//     const fetchModules = async () => {
//       try {
//         const lang = myFilter.language || "40";
//         const res = await PartnerApi.getModuleList({ language: lang });

//         const list = Array.isArray(res?.moduleList) ? res.moduleList : [];
//         const options = list
//           .filter((m) => String(m?.name || "").trim())
//           .sort((a, b) => String(a.name).localeCompare(String(b.name)))
//           .map((m) => ({ label: String(m.name).trim(), value: String(m.code) }))
//           .filter((x) => x.value);

//         setModuleOptions(options);

//         setMyFilter((prev) => ({
//           ...prev,
//           moduleCode: prev.moduleCode || options?.[0]?.value || "",
//         }));
//       } catch (err) {
//         console.error("Module list alınamadı:", err);
//       }
//     };

//     fetchModules();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const licenceTypeText =
//     data?.licenseType === "B"
//       ? "PAID"
//       : data?.licenseType === "F"
//       ? "FREE"
//       : data?.licenseType === ""
//       ? ""
//       : "";

//   return (
//     <>
//       {/* Last Modified */}
//       <div className="flex justify-end mb-2">
//         <button
//           type="button"
//           onClick={() => {
//             setSelectedLicense(data);
//             setIsModalOpen(true);
//           }}
//           className="text-blue-600 dark:text-blue-600 font-semibold text-sm hover:underline cursor-pointer transition-colors"
//         >
//           {t("Last Modified")}{" "}
//           {data?.modifiedAt
//             ? stripSeconds(formatDateTimeByLang(data.modifiedAt, i18n.language))
//             : ""}
//         </button>

//         <LicenseHistoryModal
//           isOpen={isModalOpen}
//           onClose={() => setIsModalOpen(false)}
//           data={selectedLicense}
//         />
//       </div>

//       {/* ===================== CARD 1 ===================== */}
//       <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm">
//           {/* SOL */}
//           <div className="min-w-0 space-y-2">
//             <InfoRow
//               label={t("Reseller")}
//               value={getLabelByValue(
//                 moduleOptions,
//                 myFilter.moduleCode || moduleOptions?.[0]?.value
//               )}
//             />

//             <InfoRow
//               label={t("Licence Period")}
//               value={`${formatDateByLang(data?.licenseStartDate, i18n.language) || ""} - ${
//                 formatDateByLang(data?.licenseFinishDate, i18n.language) || ""
//               }`}
//             />

//             <InfoRow
//               label={t("Version Licence")}
//               value={`${data?.minVersion ?? ""}  ${data?.licenseVersion ?? ""}`}
//             />

//             <InfoRow label={t("Type")} value={licenceTypeText} />

//             <InfoRow
//               label={t("Country")}
//               value={getLabelByValue(
//                 countryOptions,
//                 myFilter.country || countryOptions?.[0]?.value
//               )}
//             />

//             <InfoRow
//               label={t("Language")}
//               value={getLabelByValue(
//                 languageOptions,
//                 myFilter.language || languageOptions?.[0]?.value
//               )}
//             />
//           </div>

//           {/* SAĞ */}
//           <div className="min-w-0 space-y-2">
//             <InfoRow label={t("Nb Of Database")} value={data?.nbDatabase ?? ""} />
//             <InfoRow label={t("Nb Of Computer")} value={data?.nbComputer ?? ""} />

//             {Array.isArray(data?.moduleList) && data.moduleList.length > 0 && (
//               <div className="mt-2 rounded-md border border-gray-300 dark:border-white/20 bg-gray-50 dark:bg-gray-700 p-4">
//                 <h2 className="font-semibold mb-2 text-gray-800 dark:!text-white">
//                   {t("Active Modules")}:
//                 </h2>

//                 <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                   {data.moduleList.map((mod) => (
//                     <li
//                       key={mod.codeMod ?? mod.name}
//                       className="flex items-start gap-2 text-sm text-gray-700 dark:!text-white break-words"
//                     >
//                       <span
//                         className="mt-2 h-2 w-2 rounded-full bg-gray-500 dark:!bg-white flex-shrink-0"
//                         aria-hidden="true"
//                       />
//                       <span className="min-w-0 break-words">
//                         {mod.name} {mod.nbDevice > 0 ? `(${mod.nbDevice})` : ""}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ===================== CARD 2 ===================== */}
//       <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm">
//           <div className="min-w-0 space-y-2">
//             <InfoRow
//               label={t("Support Period")}
//               value={
//                 <span
//                   className={
//                     inSupportPeriod
//                       ? "text-gray-700 dark:!text-white"
//                       : "text-[#e34449] dark:text-[#e34449] font-semibold"
//                   }
//                 >
//                   {supportPeriodText}
//                 </span>
//               }
//             />

//             <InfoRow
//               label={t("Asistance")}
//               value={data?.partnerName || data?.partner || data?.partnerId || ""}
//             />

//             <InfoRow
//               label={t("Support Validation")}
//               value={supportValidationLabel}
//             />
//           </div>

//           <div className="min-w-0 space-y-2">
//             <InfoRow label={t("Support Type")} value={supportTypeLabel} />

//             <InfoRow
//               label={t("Default Support Person")}
//               value={data?.defaultSuportPersonel || ""}
//             />

//             <InfoRow label={t("Beta Level")} value={data?.betaLevel || ""} />
//           </div>
//         </div>
//       </div>

//       {/* ===================== CARD 3 ===================== */}
//       <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors">
//         <div className="mt-4">
//           <LicenseHolderInfo data={data} />
//         </div>
//       </div>
//     </>
//   );
// };

// export default LicenceList;

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PartnerApi from "../../../helpers/PartnerApi";
import LicenseHistoryModal from "../../../admin/licence/LicenseHistoryModal";
import { formatDateByLang } from "../../function/formatDate";
import { formatDateTimeByLang } from "../../function/formatDateTimeByLang";

// ✅ kendi dosya yoluna göre düzelt
import LicenseHolderInfo from "./LicenseHolderInfo";

const LicenceList = ({ data }) => {
  const { i18n, t } = useTranslation();

  const languageOptions = [
    { label: "TURKISH", value: "40" },
    { label: "GERMAN", value: "1" },
    { label: "ENGLISH", value: "3" },
    { label: "FRENCH", value: "5" },
    { label: "ARABIC", value: "19" },
  ];

  const [countryOptions, setCountryOptions] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([]);

  const [myFilter, setMyFilter] = useState({
    status: 1,
    language: "40",
    country: "",
    moduleCode: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);

  // ✅ Responsive InfoRow: label/value her ekranda sığsın
  const InfoRow = ({ label, value }) => {
    const isReactNode = React.isValidElement(value);

    const showValue =
      value === null || value === undefined || value === "" ? "" : String(value);

    return (
      <div
        className="
          grid
          grid-cols-[minmax(120px,160px)_1fr]
          sm:grid-cols-[minmax(160px,220px)_1fr]
          lg:grid-cols-[minmax(220px,320px)_1fr]
          gap-x-3 gap-y-1
          items-start
          min-w-0
          transition-colors duration-300
        "
      >
        <span
          className="
            font-medium
            text-gray-800 dark:!text-white
            whitespace-nowrap truncate
            min-w-0
          "
          title={label}
        >
          {label}:
        </span>

        <span
          className="
            min-w-0
            text-gray-700 dark:!text-white
            text-left
            font-bold

            whitespace-normal
            break-words
            [overflow-wrap:anywhere]
          "
          title={!isReactNode ? showValue : undefined}
        >
          {isReactNode ? value : showValue || "-"}
        </span>
      </div>
    );
  };

  const getLabelByValue = (options, value) => {
    const v = value ?? "";
    const found = (options || []).find((o) => String(o.value) === String(v));
    return found?.label || "";
  };

  const stripSeconds = (s = "") =>
    String(s).replace(/(\d{1,2}:\d{2})(?::\d{2})/, "$1");

  const supportValidationLabelMap = {
    S2: "+2 months of support (max 10 calls)",
    SI: "The invoice may not have arrived!",
    SA: "Support will be provided in all cases",
    XX: "No support",
  };

  const supportValidationCode = String(data?.supportValidation ?? "")
    .trim()
    .toUpperCase();

  const supportValidationLabel =
    supportValidationLabelMap[supportValidationCode] ||
    supportValidationCode ||
    "";

  const supportTypeLabelMap = {
    "": "A vérifier",
    A0: "Update",
    A1: "Telephonic",
    A2: "Remote",
    A3: "On site",
    N1: "Unwanted",
    N2: "No proposed",
    N3: "Letter send",
  };

  const supportTypeCode = String(data?.supportType ?? "").trim();
  const supportTypeLabel =
    data?.supportTypeName ||
    supportTypeLabelMap[supportTypeCode] ||
    supportTypeCode ||
    "";

  const toDateOnly = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return null;
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };

  const isTodayInRange = (start, end) => {
    const s = toDateOnly(start);
    const e = toDateOnly(end);
    if (!s || !e) return true;
    const today = toDateOnly(new Date());
    return today >= s && today <= e;
  };

  const supportStart = data?.supportStartDate;
  const supportFinish = data?.supportFinishDate;
  const inSupportPeriod = isTodayInRange(supportStart, supportFinish);

  const supportPeriodText = `${formatDateByLang(supportStart, i18n.language) || ""} - ${
    formatDateByLang(supportFinish, i18n.language) || ""
  }`;

  // ✅ Countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await PartnerApi.getCountryList({
          language: myFilter.language || "40",
          status: myFilter.status ?? 1,
          limit: 500,
          offset: 0,
        });

        const list = Array.isArray(res?.countryList) ? res.countryList : [];
        const options = list
          .filter((c) => String(c?.name || "").trim())
          .sort((a, b) => String(a.name).localeCompare(String(b.name)))
          .map((c) => ({
            label: String(c.name).trim(),
            value: String(c.code ?? c.countryCode ?? c.id ?? "").trim(),
          }))
          .filter((x) => x.value);

        setCountryOptions(options);

        setMyFilter((prev) => ({
          ...prev,
          country: prev.country || options?.[0]?.value || "",
        }));
      } catch (error) {
        console.error("Ülke listesi alınamadı:", error);
      }
    };

    fetchCountries();
  }, [myFilter.language, myFilter.status]);

  // ✅ Modules
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const lang = myFilter.language || "40";
        const res = await PartnerApi.getModuleList({ language: lang });

        const list = Array.isArray(res?.moduleList) ? res.moduleList : [];
        const options = list
          .filter((m) => String(m?.name || "").trim())
          .sort((a, b) => String(a.name).localeCompare(String(b.name)))
          .map((m) => ({ label: String(m.name).trim(), value: String(m.code) }))
          .filter((x) => x.value);

        setModuleOptions(options);

        setMyFilter((prev) => ({
          ...prev,
          moduleCode: prev.moduleCode || options?.[0]?.value || "",
        }));
      } catch (err) {
        console.error("Module list alınamadı:", err);
      }
    };

    fetchModules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const licenceTypeText =
    data?.licenseType === "B"
      ? "PAID"
      : data?.licenseType === "F"
      ? "FREE"
      : data?.licenseType === ""
      ? ""
      : "";

  return (
    <>
      {/* Last Modified */}
      <div className="flex justify-end mb-2 min-w-0">
        <button
          type="button"
          onClick={() => {
            setSelectedLicense(data);
            setIsModalOpen(true);
          }}
          className="
            text-blue-600 dark:text-blue-600
            font-semibold text-sm
            hover:underline cursor-pointer transition-colors
            truncate max-w-full
          "
          title={
            data?.modifiedAt
              ? stripSeconds(formatDateTimeByLang(data.modifiedAt, i18n.language))
              : ""
          }
        >
          {t("Last Modified")}{" "}
          {data?.modifiedAt
            ? stripSeconds(formatDateTimeByLang(data.modifiedAt, i18n.language))
            : ""}
        </button>

        <LicenseHistoryModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={selectedLicense}
        />
      </div>

      {/* ===================== CARD 1 ===================== */}
      <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors min-w-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm min-w-0">
          {/* SOL */}
          <div className="min-w-0 space-y-2">
            <InfoRow
              label={t("Reseller")}
              value={getLabelByValue(
                moduleOptions,
                myFilter.moduleCode || moduleOptions?.[0]?.value
              )}
            />

            <InfoRow
              label={t("Licence Period")}
              value={`${formatDateByLang(data?.licenseStartDate, i18n.language) || ""} - ${
                formatDateByLang(data?.licenseFinishDate, i18n.language) || ""
              }`}
            />

            <InfoRow
              label={t("Version Licence")}
              value={`${data?.minVersion ?? ""}  ${data?.licenseVersion ?? ""}`}
            />

            <InfoRow label={t("Type")} value={licenceTypeText} />

            <InfoRow
              label={t("Country")}
              value={getLabelByValue(
                countryOptions,
                myFilter.country || countryOptions?.[0]?.value
              )}
            />

            <InfoRow
              label={t("Language")}
              value={getLabelByValue(
                languageOptions,
                myFilter.language || languageOptions?.[0]?.value
              )}
            />
          </div>

          {/* SAĞ */}
          <div className="min-w-0 space-y-2">
            <InfoRow label={t("Nb Of Database")} value={data?.nbDatabase ?? ""} />
            <InfoRow label={t("Nb Of Computer")} value={data?.nbComputer ?? ""} />

            {Array.isArray(data?.moduleList) && data.moduleList.length > 0 && (
              <div className="mt-2 rounded-md border border-gray-300 dark:border-white/20 bg-gray-50 dark:bg-gray-700 p-4 min-w-0">
                <h2 className="font-semibold mb-2 text-gray-800 dark:!text-white">
                  {t("Active Modules")}:
                </h2>

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 min-w-0">
                  {data.moduleList.map((mod) => (
                    <li
                      key={mod.codeMod ?? mod.name}
                      className="flex items-start gap-2 text-sm text-gray-700 dark:!text-white min-w-0"
                    >
                      <span
                        className="mt-2 h-2 w-2 rounded-full bg-gray-500 dark:!bg-white flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span className="min-w-0 break-words [overflow-wrap:anywhere]">
                        {mod.name} {mod.nbDevice > 0 ? `(${mod.nbDevice})` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ===================== CARD 2 ===================== */}
      <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors min-w-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm min-w-0">
          <div className="min-w-0 space-y-2">
            <InfoRow
              label={t("Support Period")}
              value={
                <span
                  className={
                    inSupportPeriod
                      ? "text-gray-700 dark:!text-white"
                      : "text-[#e34449] dark:text-[#e34449] font-semibold"
                  }
                >
                  {supportPeriodText}
                </span>
              }
            />

            <InfoRow
              label={t("Asistance")}
              value={data?.partnerName || data?.partner || data?.partnerId || ""}
            />

            <InfoRow label={t("Support Validation")} value={supportValidationLabel} />
          </div>

          <div className="min-w-0 space-y-2">
            <InfoRow label={t("Support Type")} value={supportTypeLabel} />

            <InfoRow
              label={t("Default Support Person")}
              value={data?.defaultSuportPersonel || ""}
            />

            <InfoRow label={t("Beta Level")} value={data?.betaLevel || ""} />
          </div>
        </div>
      </div>

      {/* ===================== CARD 3 ===================== */}
      <div className="border border-gray-300 dark:border-gray-400 rounded-lg bg-white dark:bg-gray-600 shadow dark:shadow-gray-800/50 p-4 mb-6 transition-colors min-w-0">
        <div className="mt-2 min-w-0">
          <LicenseHolderInfo data={data} />
        </div>
      </div>
    </>
  );
};

export default LicenceList;
